import * as actions from "../../Action/SuperAdmin/TenantCreation";

export const initialState = {
  tenantName: "",
  tenantKey: "",
  tenantMobile: "",
  tenantTelephone: "",
  tenantEmail: "",
  tenantDes: "",
  tenantServicePlan: "",
  addressLine1: "",
  addressLine2: "",
  tenantCountry: "",
  tenantState: "",
  tenantCity: "",
  tenantPostalCode: "",
  tenantLogo: "",
  loaderStatus: false,
  tenantCreationFailure: null,
  tenantUserLimit: 0,
  activationDate: "",
  tenantRenewalDate: "",
  tenantValidDate: "",
  primeSubscription: false,
  tenantMatrix:"",
  isTasksModuleEnabled:false

};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.TENANTNAME:
      return tenantName(state, action);
    case actions.TENANTKEY:
      return tenantKey(state, action);
    case actions.TENANTMOBILE:
      return tenantMobile(state, action);
    case actions.TENANATTELEPHONE:
      return tenantTelephone(state, action);
    case actions.TENANTEMAIL:
      return tenantEmail(state, action);
    case actions.TENANTUSERLIMITS:
      return tenantUserLimits(state, action);
    case actions.TENANTDESC:
      return tenantDesc(state, action);
    case actions.TENANTSERVICEPLAN:
      return tenantServicePlan(state, action);
    case actions.ADDRESSLINE1:
      return addressLine1(state, action);
    case actions.ADDRESSLINE2:
      return addressLine2(state, action);
    case actions.TENANTCOUNTRY:
      return tenantCountry(state, action);
    case actions.TENANTSTATE:
      return tenantState(state, action);
    case actions.TENANTCITY:
      return tenantCity(state, action);
    case actions.TENANTPOSTALCODE:
      return tenantPostalCode(state, action);
    case actions.TENANTLOGO:
      return tenantLogo(state, action);
    case actions.RESETDATA:
      return ResetData(state, action);
    case actions.LOGGEDINLOADER:
      return loggedInLoader(state, action);
    case actions.TENANTFALIURE:
      return tenantcreationFailure(state, action);
    case actions.ACTIVATIONDATE:
      return activationDate(state, action);
    case actions.TENANTRENEWALDATE:
      return tenantRenewalDate(state, action);
    case actions.TENANTVALIDDATE:
      return tenantValidDate(state, action);
    case actions.PRIMESUBSCRIPTION:
      return primeSubscription(state, action);
    case actions.ISTASKMODULEENABLED:
      return handleTasksModuleEnabled(state, action);
   case actions.TENANTMATRIX:
      return tenantMatrix(state, action);
    default:
      return state;
  }
}

const tenantName = (state, action) => {
  return {
    ...state,
    tenantName: action.payload,
  };
};

const tenantKey = (state, action) => {
  return {
    ...state,
    tenantKey: action.payload,
  };
};

const tenantMobile = (state, action) => {
  return {
    ...state,
    tenantMobile: action.payload,
  };
};

const tenantTelephone = (state, action) => {
  return {
    ...state,
    tenantTelephone: action.payload,
  };
};

const tenantEmail = (state, action) => {
  return {
    ...state,
    tenantEmail: action.payload,
  };
};

const tenantUserLimits = (state, action) => {
  console.log(action.payload);
  return {
    ...state,
    tenantUserLimit: action.payload,
  };
};

const tenantDesc = (state, action) => {
  return {
    ...state,
    tenantDes: action.payload,
  };
};

const tenantServicePlan = (state, action) => {
  return {
    ...state,
    tenantServicePlan: action.payload,
  };
};

const addressLine1 = (state, action) => {
  return {
    ...state,
    addressLine1: action.payload,
  };
};

const addressLine2 = (state, action) => {
  return {
    ...state,
    addressLine2: action.payload,
  };
};

const tenantCountry = (state, action) => {
  return {
    ...state,
    tenantCountry: action.payload,
  };
};
const tenantState = (state, action) => {
  return {
    ...state,
    tenantState: action.payload,
  };
};
const tenantCity = (state, action) => {
  return {
    ...state,
    tenantCity: action.payload,
  };
};
const tenantPostalCode = (state, action) => {
  return {
    ...state,
    tenantPostalCode: action.payload,
  };
};

const tenantLogo = (state, action) => {
  return {
    ...state,
    tenantLogo: action.payload,
  };
};

const loggedInLoader = (state, action) => {
  return {
    ...state,
    loaderStatus: action.payload,
  };
};

const tenantcreationFailure = (state, action) => {
  return {
    ...state,
    tenantCreationFailure: action.payload,
  };
};
const activationDate = (state, action) => {
  return {
    ...state,
    activationDate: action.payload,
  };
};
const tenantRenewalDate = (state, action) => {
  return {
    ...state,
    tenantRenewalDate: action.payload,
  };
};
const tenantValidDate = (state, action) => {
  return {
    ...state,
    tenantValidDate: action.payload,
  };
};
const primeSubscription = (state, action) => {
  return {
    ...state,
    primeSubscription: action.payload,
  };
};
const handleTasksModuleEnabled = (state, action) => {
  return {
    ...state,
    isTasksModuleEnabled: action.payload,
  };
};
const tenantMatrix = (state, action) => {
  return {
    ...state,
    tenantMatrix: action.payload,
  };
};

const ResetData = (state, action) => {
  return {
    ...state,
    tenantName: "",
    tenantKey: "",
    tenantMobile: "",
    tenantTelephone: "",
    tenantEmail: "",
    tenantDes: "",
    tenantServicePlan: "",
    addressLine1: "",
    addressLine2: "",
    tenantCountry: "",
    tenantState: "",
    tenantCity: "",
    tenantPostalCode: "",
    tenantLogo: "",
    tenantUserLimit: 0,
    activationDate: "",
    tenantRenewalDate: "",
    tenantValidDate: "",
    primeSubscription: false,
    isTasksModuleEnabled:false,
    tenantMatrix:"",
  };
};
